import { useState, useEffect } from 'react'

import { history } from 'services/history.js'
import { formatMoneyCents } from 'services/util'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'
import auctionCardCss from './sass/auctionscards.module.scss'
import AuctionEndedCardPaid from './AuctionEndedCardPaid'

export default function AuctionEndedCard({ auction, route, outstandingBalance }) {
  const [fixedAmountDue, setFixedAmountDue] = useState()
  const [bidAmountDue, setBidAmountDue] = useState()
  const [donationDue, setDonationDue] = useState()
  const [amountDue, setAmountDue] = useState()

  useEffect(() => {

    setBidAmountDue(outstandingBalance?.bidItems)
    setFixedAmountDue(outstandingBalance?.fixedItems)
    setDonationDue(outstandingBalance?.donations)
    setAmountDue(outstandingBalance?.total)

  }, [outstandingBalance])

  const proceedToCheckout = () => {
    if (route !== 'auction') localStorage.setItem('myItems', true)
    
    history.push({
      pathname: '/checkout',
      search: `?auctionId=${auction.AuctionCode}`,
    })
  }

  if (amountDue === undefined) return <></>

  return(

    <div className={`${themeCss['box-top-yellow-accent-wide']} ${css['auction-ended-card']}`} >
      <p className={auctionCardCss['auction-box-info-heading']}>Thank you for participating!</p>
      {/* <p className={auctionCardCss['auction-box-info-text']}>Below are the items you've purchased or donations you've made.</p> */}
      <p className={auctionCardCss['auction-box-info-text']}>You have items and/or donations ready for checkout. Please click below to complete your checkout.</p>
      <div className={css['auction-amount-container']}>
        <div>
          <p className={css['auction-amount-due-label']}>Amount Due</p>
          <p className={css['auction-amount-due']}>{`$${formatMoneyCents(amountDue)}`}</p>
        </div>
        <div>
          {bidAmountDue > 0 && <p className={css['auction-amount-outstanding-rows']}>Auction Items: <span>${formatMoneyCents(bidAmountDue)}</span> </p>}
          {fixedAmountDue > 0 && <p className={css['auction-amount-outstanding-rows']}>Buy Now Items: <span>${formatMoneyCents(fixedAmountDue)}</span> </p>}
          {donationDue > 0 && <p className={css['auction-amount-outstanding-rows']}>Donations: <span>${formatMoneyCents(donationDue)}</span> </p>}
        </div>
      </div>
      
      <button onClick ={() => proceedToCheckout()} className={`${themeCss['FilledYellow']} ${themeCss['button']} ${css['button-to-checkout']}`}>
        Proceed to Checkout
      </button>
    </div>
  )
}